import React, { useEffect, useState } from "react"
import ViewItemPage from "../../../../entities/DashboardPage/AccountingModule/ViewItemPage"
import { useLocation } from "react-router-dom";
import AuthService from "../../../../api/AuthService";

function ViewItem() {
  const [loading, setLoading] = useState(false);
  const [supplierList, setSupplierList] = useState();
  const [ItemData, setItemData] = useState()
  const { state } = useLocation();
  const { item } = state || {};

  useEffect(() => {
    getOneItemData(item?._id)
    getSupplierList()
  }, [item])

  const getOneItemData = async (id) => {
    setLoading(true);
    try {
      const result = await AuthService.getOneItem(id);
      if (result?.success) {
        setItemData(result?.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getSupplierList = async (text, sort, page) => {
    setLoading(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setSupplierList(result?.data?.suppliers);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleMarkActive = async (mark) => {
    setLoading(true);
    try {
      const result = await AuthService.markItemActive(item?._id, mark);
      if (result?.success) {
        setLoading(false);
        getOneItemData(item?._id);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <ViewItemPage ItemData={ItemData} supplierList={supplierList} handleMarkActive={handleMarkActive} />
  )
}


export default ViewItem